// Простой markdown без библиотек: **жирный**, списки, заголовки, переносы.
// Всё собирается React-элементами — сырой текст в разметку не попадает.
import React from 'react';

function inline(text, keyBase) {
  const out = [];
  const re = /\*\*(.+?)\*\*|__(.+?)__/g;
  let last = 0, m, i = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(<strong key={`${keyBase}-${i++}`}>{m[1] || m[2]}</strong>);
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export default function Markdown({ text }) {
  const lines = String(text || '').replace(/\r/g, '').split('\n');
  const blocks = [];
  let para = [];
  let list = null;
  const flushPara = () => {
    if (para.length) { blocks.push({ t: 'p', lines: para }); para = []; }
  };
  const flushList = () => { if (list) { blocks.push(list); list = null; } };
  for (const raw of lines) {
    const line = raw.trimEnd();
    const ul = line.match(/^\s*[-*•]\s+(.*)$/);
    const ol = line.match(/^\s*\d+[.)]\s+(.*)$/);
    const h = line.match(/^#{1,6}\s+(.*)$/);
    if (ul || ol) {
      flushPara();
      const kind = ul ? 'ul' : 'ol';
      if (!list || list.t !== kind) { flushList(); list = { t: kind, items: [] }; }
      list.items.push((ul || ol)[1]);
    } else if (h) {
      flushPara(); flushList();
      blocks.push({ t: 'h', text: h[1] });
    } else if (line.trim() === '') {
      flushPara(); flushList();
    } else {
      flushList();
      para.push(line);
    }
  }
  flushPara(); flushList();
  return (
    <div className="ai-md">
      {blocks.map((b, i) => {
        if (b.t === 'h') return <p key={i}><strong>{inline(b.text, i)}</strong></p>;
        if (b.t === 'ul' || b.t === 'ol') {
          const Tag = b.t;
          return <Tag key={i}>{b.items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}</Tag>;
        }
        return (
          <p key={i}>
            {b.lines.map((l, j) => (
              <React.Fragment key={j}>{j > 0 && <br />}{inline(l, `${i}-${j}`)}</React.Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}
